import React, { useContext, useEffect, useRef, useSyncExternalStore } from 'react';
import { AppContext } from '../window';
import { getBaseTitle, subscribeBaseTitle } from '../utils/documentHead';

/**
 * Prefixes the unread count to the page title. The title is the one the
 * server rendered, or the one a page set through `setBaseTitle()`
 * (`utils/documentHead.ts`, custom frontend pages).
 */
const TitleComponent: React.FC = () => {
  const { user } = useContext(AppContext);
  const originalTitleRef = useRef<string>(document.title);
  const baseTitle = useSyncExternalStore(subscribeBaseTitle, getBaseTitle);

  useEffect(() => {
    const unreadCount = user?.unreadMessageCount || 0;
    const title = baseTitle ?? originalTitleRef.current;

    document.title = unreadCount > 0 ? `(${unreadCount}) ${title}` : title;
  }, [user?.unreadMessageCount, baseTitle]);

  return null;
};

export default TitleComponent;
